
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';

function zeroPadded(num: number) {
  // 4 --> 04
  return num < 10 ? `0${num}` : num;
}

function hourConvert(hour: number) {
  // 15 --> 3
  return hour % 12 || 12;
}

export default defineComponent({
  name: 'count-down',
  data() {
    return {
      rateLimiter:0,
      matchOver: false,
      intervalTimer: 0,
      selectedTime: 0,
      timeLeft: '0h 0m 0s',
      endTime: '00:00',
      times: [
        {
          sec: 3,
          display: '3s',
        },
        {
          sec: 600,
          display: ' 10m',
        },
        {
          sec: 1800,
          display: '30m',
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      tournament: 'tournament/getTournament',
    }),
  },
  watch: {
    tournament: {
      handler(value) {
        this.newTimer();
      },
    },
  },

  methods: {
    ...mapActions({
      loadTournament: 'tournament/get',
    }),
    newTimer() {
      const countDownDate = this.tournament.endMatch * 1000;
      this.displayEndTime(countDownDate);
      // Update the count down every 1 second
      const x = setInterval( () => {

        // Get today's date and time
        const now = new Date().getTime();
          
        // Find the distance between now and the count down date
        const distance = countDownDate - now;
          
        // Time calculations for days, hours, minutes and seconds
        // var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
          
        // Output the result in an element with id="demo"
        this.timeLeft =` ${hours}h  ${minutes}m ${seconds}s`;
          
        // If the count down is over, write some text 
        if (distance < 0) {
          clearInterval(x);
          this.timeLeft = "ENDED";
          this.matchOver = true;
          if (this.tournament.status === 'started') {
            this.loadTournament(this.tournament.id);
            this.rateLimiter+=1;
          }
            
        }
      }, 1000);
    },

    displayEndTime(timestamp: number) {
      const end = new Date(timestamp);
      const hour = end.getHours();
      const minutes = end.getMinutes();

      this.endTime = `${hourConvert(hour)}:${zeroPadded(minutes)}`;
    },
  },
});

